export default __webpack_public_path__ + "static/BioRhyme-Light-hint-all-9a13ba234144efab1d2097b4c7a0f30c.woff2";